module.exports = __webpack_public_path__ + "dd8a91b8196000643e3383d81c659ecb.svg";